export function loadAppFont(): void {
  const fontHolder = document.getElementById('sourcesans-font');

  if (fontHolder) {
    fontHolder.removeAttribute('media');
  }
}
